import { Button, ButtonProps } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface EditButtonProps extends ButtonProps {
  productId: string;
  footprintId: string;
  calculationId: string;
}

const EditButton = (props: EditButtonProps): JSX.Element => {
  const navigate = useNavigate();
  const { productId, footprintId, calculationId, ...restProps } = props;
  const { t } = useTranslation();

  const onClick = () => {
    const href = `/products/${productId}/pcf/footprint/${footprintId}/calculations/${calculationId}`;
    navigate(href);
  };

  return (
    <Button
      label={t('calculationsPage.calculationTableColumns.editButton')}
      text
      onClick={onClick}
      {...restProps}
    />
  );
};

export default EditButton;
